<template>
    <div>
        <MatchInfo v-bind:event="event" class="upcomingMatch" />
        <MarketsPanel
            v-bind:event="event"
            v-bind:marketTypes="TOURNAMENT_CENTER_ALL_MARKET_TYPES"
            v-bind:displaySection="DisplaySection.TournamentCenter_UpcomingMatches"
        />
    </div>
</template>

<script lang="ts" setup>
    import MarketsPanel from '@/components/tournamentCenter/MarketsPanel.vue';
    import MatchInfo from '@/components/tournamentCenter/MatchInfo.vue';
    import { TOURNAMENT_CENTER_ALL_MARKET_TYPES } from '@/components/tournamentCenter/config';
    import { DisplaySection } from '@/interface/enum';
    import type { ITournamentEvent } from '@/interface/tournamentCenter';

    defineProps<{
        event: ITournamentEvent;
    }>();
</script>

<style lang="scss" scoped>
    @import "@/components/tournamentCenter/UpcomingMatch";
</style>
